import { releasesCatalogState } from "./releases/state";
import { productsCatalogState } from "./products/state";
import { product_groupsCatalogState } from './product_groups/state';
import { tracksCatalogState } from './tracks/state';
import { artistsCatalogState } from './artists/state';
import { labelsCatalogState } from './labels/state';
import { CatalogModulePluginStore } from "./plugin-store";
import { from } from "rxjs";
import { projectsCatalogState } from "./projects/state";
export const state = {
  ...productsCatalogState,
  ...releasesCatalogState,
  ...product_groupsCatalogState,
  ...tracksCatalogState,
  ...artistsCatalogState,
  ...labelsCatalogState,
  ...projectsCatalogState,
  ...CatalogModulePluginStore.state
};
